/*
document.addEventListener("DOMContentLoaded", function() {
  // Function to get the current cart
  async function getCart() {
    try {
      const response = await fetch("/cart.js");
      return await response.json();
    } catch (error) {
      console.error("Error fetching cart:", error);
      return null;
    }
  }

  // Function to add a product to the cart
  async function addProductToCart(variantId, quantity = 1) {
    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: quantity,
            },
          ],
        }),
      });
      return await response.json();
    } catch (error) {
      console.error("Error adding product to cart:", error);
      return null;
    }
  }

  // Function to check if a product is already in the cart
  function isProductInCart(cart, variantId) {
    return cart.items.some((item) => item.variant_id === variantId);
  }

  // Function to handle cart logic
  async function handleCartUpdate() {
    const cart = await getCart();
    if (!cart) return;

    const cartTotal = cart.total_price / 100; // Convert from cents to dollars
    const freeProduct1Id = 12345; // First free product variant ID
    const freeProduct2Id = 54321; // Second free product variant ID

    // Check if cart value is over $100 but under $200
    if (cartTotal >= 100 && cartTotal < 200) {
      if (!isProductInCart(cart, freeProduct1Id)) {
        console.log("Adding free product 1 to cart");
        //await addProductToCart(freeProduct1Id);
      }
    }
    // Check if cart value is over $200
    else if (cartTotal >= 200) {
      if (!isProductInCart(cart, freeProduct2Id)) {
        console.log("Adding free product 2 to cart");
        //await addProductToCart(freeProduct2Id);
      }
    }
  }

  // Listen for Ajax requests to detect cart updates
  const originalFetch = window.fetch;
  window.fetch = function(url, options) {
    const fetchPromise = originalFetch.apply(this, arguments);
    
    if (
      typeof url === "string" &&
      (url.includes("/cart/add") || url.includes("/cart/update") || url.includes("/cart/change"))
    ) {
      console.log('url', url);
      fetchPromise.then(() => {
        setTimeout(handleCartUpdate, 500); // Slight delay to ensure cart is updated
      });
    }
    
    return fetchPromise;
  };

  // Also check on page load
  handleCartUpdate();
});
*/

document.addEventListener("DOMContentLoaded", function() {
  // Flag to prevent concurrent updates
  let isProcessingCartUpdate = false;
  
  // Function to get the current cart
  async function getCart() {
    try {
      const response = await fetch("/cart.js");
      return await response.json();
    } catch (error) {
      console.error("Error fetching cart:", error);
      return null;
    }
  }

  // Function to add items to cart
  async function addItemsToCart(items) {
    try {
      if (!items || items.length === 0) return null;
      
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items: items
        }),
      });
      
      return await response.json();
    } catch (error) {
      console.error("Error adding items to cart:", error);
      return null;
    }
  }
  
  // Function to update cart quantities
  async function updateCartQuantities(updates) {
    try {
      if (!updates || Object.keys(updates).length === 0) return null;
      
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          updates: updates
        }),
      });
      
      return await response.json();
    } catch (error) {
      console.error("Error updating cart quantities:", error);
      return null;
    }
  }

  // Function to handle cart operations with separate add and update calls
  async function processCartChanges(updates = {}, itemsToAdd = []) {
    try {
      let cartUpdated = false;
      
      // First handle quantity updates/removals
      if (Object.keys(updates).length > 0) {
        await updateCartQuantities(updates);
        cartUpdated = true;
      }
      
      // Then handle additions
      if (itemsToAdd.length > 0) {
        // Mark items as free gifts
        itemsToAdd.forEach(item => {
          item.properties = item.properties || {};
          item.properties._free_gift = true;
        });
        
        await addItemsToCart(itemsToAdd);
        cartUpdated = true;
      }
      
      return cartUpdated;
    } finally {
      isProcessingCartUpdate = false;
    }
  }

  // Function to check if a product is already in the cart
  function isProductInCart(cart, variantId) {
    return cart.items.some((item) => item.variant_id === variantId);
  }

  // Find line item key for a variant
  function getLineItemKey(cart, variantId) {
    const item = cart.items.find(item => item.variant_id === variantId);
    return item ? item.key : null;
  }

  // Function to handle cart logic
  async function handleCartUpdate() {
    // Prevent concurrent updates
    if (isProcessingCartUpdate) {
      console.log("Cart update already in progress, skipping");
      return;
    }
    
    isProcessingCartUpdate = true;
    
    const cart = await getCart();
    if (!cart) {
      isProcessingCartUpdate = false;
      return;
    }

    const cartTotal = cart.total_price / 100; // Convert from cents to dollars
    const freeProduct1Id = 47226166247743; // First free product variant ID
    const freeProduct2Id = 47226166313279; // Second free product variant ID
    
    const hasProduct1 = isProductInCart(cart, freeProduct1Id);
    const hasProduct2 = isProductInCart(cart, freeProduct2Id);
    
    // Prepare updates object for modifying existing line items
    const updates = {};
    // Prepare items array for adding new products
    const itemsToAdd = [];

    // If cart is under $100, remove both free products if they exist
    if (cartTotal < 100) {
      if (hasProduct1) {
        const key = getLineItemKey(cart, freeProduct1Id);
        //if (key) updates[key] = 0; // Set quantity to 0 to remove
      }
      if (hasProduct2) {
        const key = getLineItemKey(cart, freeProduct2Id);
        //if (key) updates[key] = 0; // Set quantity to 0 to remove
      }
    }
    // If cart value is between $100 and $200
    else if (cartTotal >= 100 && cartTotal < 200) {
      // Add free product 1 if not already in cart
      if (!hasProduct1) {
        console.log("Adding free product 1 to cart");
        itemsToAdd.push({
          id: freeProduct1Id,
          quantity: 1,
          properties: { _free_gift: true }
        });
      }
      // Remove free product 2 if it's in the cart
      if (hasProduct2) {
        const key = getLineItemKey(cart, freeProduct2Id);
        if (key) updates[key] = 0; // Set quantity to 0 to remove
      }
    }
    // If cart value is $200+
    else if (cartTotal >= 200) {
      // Add free product 2 if not already in cart
      if (!hasProduct2) {
        console.log("Adding free product 2 to cart");
        itemsToAdd.push({
          id: freeProduct2Id,
          quantity: 1,
          properties: { _free_gift: true }
        });
      }
      // Remove free product 1 if it's in the cart
      if (hasProduct1) {
        const key = getLineItemKey(cart, freeProduct1Id);
        if (key) updates[key] = 0; // Set quantity to 0 to remove
      }
    }

    // Disable fetch interception during our operations
    shouldInterceptFetch = false;
    
    // Process cart changes
    const cartChanged = await processCartChanges(updates, itemsToAdd);
    
    // If cart was changed, update the cart drawer
    if (cartChanged) {
      const x = new CartDrawer();
      x.rerenderCart();
    } else {
      isProcessingCartUpdate = false;
    }
    
    // Re-enable fetch interception after a delay
    setTimeout(() => {
      shouldInterceptFetch = true;
    }, 1000);
  }

  // Flag to control fetch interception
  let shouldInterceptFetch = true;

  // Listen for Ajax requests to detect cart updates
  const originalFetch = window.fetch;
  window.fetch = function(url, options) {
    const fetchPromise = originalFetch.apply(this, arguments);
    
    if (
      shouldInterceptFetch &&
      typeof url === "string" &&
      (url.includes("/cart/add") || url.includes("/cart/update") || url.includes("/cart/change")) &&
      !isProcessingCartUpdate
    ) {
      fetchPromise.then(() => {
        // Prevent immediate re-triggers
        setTimeout(handleCartUpdate, 500);
      });
    }
    
    return fetchPromise;
  };

  // Check on page load
  handleCartUpdate();
});

